import React from "react";
import { Space } from "antd";
import ClassCard, { CardItem } from "./ClassCard";
import { ClassOption } from "../types";

interface SelectedClassesListProps {
  selectedItems: ClassOption[];
  onDelete: (value: string) => void;
  selectedCard: string | null;
  progressLimit: number;
  onItemDelete: (value: string, mediaId: string) => void;
  classItemsMap?: Record<string, CardItem[]>;
}

export default function SelectedClassesList({
  selectedItems,
  onDelete,
  selectedCard,
  progressLimit,
  onItemDelete,
  classItemsMap,
}: SelectedClassesListProps) {
  return (
    <Space direction="vertical" size="middle" style={{ width: "100%" }}>
      {selectedItems.map((item) => (
        <ClassCard
          key={item.value}
          value={item.label}
          onDelete={onDelete}
          min={progressLimit}
          isSelected={selectedCard === item.value}
          itemCount={classItemsMap?.[item.value]?.length || 0}
          progressValue={classItemsMap?.[item.value]?.length || 0}
          items={classItemsMap?.[item.value] || []}
          onItemDelete={onItemDelete}
          classId={item.value}
        />
      ))}
    </Space>
  );
}
